import { ShieldAlert } from "lucide-react";

function EmptyRoles() {

    return (

        <div className="empty-state">

            <ShieldAlert size={55} />

            <h3>No Roles Found</h3>

            <p>
                There are no roles available.
            </p>

        </div>

    );

}

export default EmptyRoles;